"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const ActorGroup = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "4 4 16 16"
}, props), _react.default.createElement("path", {
  d: "M6 16c0 .179.354.598 1.238 1.04 1.197.598 2.908.96 4.762.96 1.854 0 3.565-.362 4.762-.96C17.646 16.598 18 16.179 18 16h2c0 2.21-3.582 4-8 4s-8-1.79-8-4h2zm0-4c0 .179.354.598 1.238 1.04 1.197.598 2.908.96 4.762.96 1.854 0 3.565-.362 4.762-.96C17.646 12.598 18 12.179 18 12h2c0 2.21-3.582 4-8 4s-8-1.79-8-4h2zm6-8c4.418 0 8 1.79 8 4s-3.582 4-8 4-8-1.79-8-4 3.582-4 8-4zm0 2c-1.854 0-3.565.362-4.762.96C6.354 7.402 6 7.821 6 8c0 .179.354.598 1.238 1.04 1.197.598 2.908.96 4.762.96 1.854 0 3.565-.362 4.762-.96C17.646 8.598 18 8.179 18 8c0-.179-.354-.598-1.238-1.04C15.565 6.362 13.854 6 12 6z",
  fill: "#BBC4CD",
  fillRule: "nonzero",
  className: "fill"
}));

var _default = ActorGroup;
exports.default = _default;